"use client";

function SkeletonLine({ className = "" }: Readonly<{ className?: string }>) {
  return (
    <div
      className={`animate-pulse rounded-full bg-gail-silver/30 ${className}`}
    />
  );
}

export default function JobCardSkeleton() {
  return (
    <article
      className="flex h-full min-h-[320px] flex-col rounded-2xl border border-gail-silver/50 bg-white p-6 shadow-sm"
      aria-hidden="true"
    >
      <SkeletonLine className="h-7 w-32" />

      <div className="mt-6 space-y-3">
        <SkeletonLine className="h-8 w-4/5" />
        <SkeletonLine className="h-8 w-3/5" />
      </div>

      <div className="mt-5 flex-1 space-y-3">
        <SkeletonLine className="h-4 w-full" />
        <SkeletonLine className="h-4 w-11/12" />
        <SkeletonLine className="h-4 w-4/5" />
      </div>

      <div className="mt-6 space-y-3">
        <SkeletonLine className="h-4 w-48" />
        <SkeletonLine className="h-4 w-40" />
      </div>

      <div className="mt-6 flex items-center justify-between gap-4 border-t border-gail-silver/30 pt-4">
        <div className="flex items-center gap-2">
          <SkeletonLine className="h-4 w-12" />
          <SkeletonLine className="h-8 w-28" />
        </div>
        <SkeletonLine className="h-10 w-20" />
      </div>
    </article>
  );
}
